// react
import React from "react";

// react-router-dom
import { useNavigate, useLocation } from "react-router-dom";

// context
import { UserAuth } from "context/AuthContext";

// react-i18next
import { useTranslation } from "react-i18next";

// @mui
import { Drawer, Toolbar, List, ListItem, ListItemIcon, ListItemText, Box, Divider } from "@mui/material";
import { Archive as ArchiveIcon, Groups as GroupsIcon, Business as BusinessIcon } from "@mui/icons-material";

// ui-components
import Copyright from "ui-components/Copyright";

// A ---------------------------------------------------------------------- M

const NavigationItem = ({ onClick, icon, text, active }) => {
  return (
    <ListItem
      onClick={onClick}
      sx={{
        py: 1.2,
        px: 2,
        mb: 0.5,
        borderRadius: 8,
        transition: "all 0.2s ease",
        backgroundColor: active ? "rgba(255,255,255,0.05)" : "transparent",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          transform: "scale(1.03)",
          boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
          cursor: "pointer",
        },
      }}
    >
      <ListItemIcon sx={{ minWidth: 36, color: active ? "#ffffff" : "rgba(255, 255, 255, 0.7)" }}>{icon}</ListItemIcon>
      <ListItemText
        primary={text}
        primaryTypographyProps={{
          variant: "body2",
          color: active ? "#ffffff" : "rgba(255, 255, 255, 0.8)",
        }}
      />
    </ListItem>
  );
};

const TrustConserveSidebar = ({ drawerWidth }) => {
  const { user, isInternal } = UserAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (item) => {
    if (item.route && location.pathname !== item.route) {
      navigate(item.route);
    } else if (item.onClick) {
      item.onClick();
    }
  };

  const menuItems = [
    { text: t("my_archives"), icon: <ArchiveIcon />, route: "/" },
    { text: t("my_groups"), icon: <GroupsIcon />, route: "/my-groups" },
    isInternal && {
      text: t("customer_records"),
      icon: <BusinessIcon />,
      route: "/customers",
    },
  ].filter(Boolean);

  return (
    <Drawer
      open
      variant="permanent"
      sx={{
        width: drawerWidth,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          background: "linear-gradient(180deg, rgba(13,71,161,0.85) 0%, rgba(10,53,122,0.95) 100%)",
          backdropFilter: "blur(10px)",
          borderRight: "1px solid rgba(255,255,255,0.08)",
          display: "flex",
          flexDirection: "column",
          transition: "background-color 0.3s ease",
          boxShadow: "inset 0 0 20px rgba(0,0,0,0.4)",
        },
      }}
    >
      <Toolbar />

      <List sx={{ px: 1.5, pt: 1 }}>
        {user && menuItems.map((item, index) => <NavigationItem key={index} onClick={() => handleNavigation(item)} icon={item.icon} text={item.text} active={location.pathname === item.route} />)}
      </List>

      <Box sx={{ p: 2, mt: "auto" }}>
        <Divider
          sx={{
            mb: 1.5,
            borderColor: "rgba(255, 255, 255, 0.15)",
          }}
        />
        <Copyright />
      </Box>
    </Drawer>
  );
};

export default TrustConserveSidebar;
